





























































































































import {
  Vue,
  Component,
  Prop,
  Watch
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { BankAccountHoldFunctionType, HoldAccountInformationModel } from "@/employer/types";
import { UserHsaAccountStatus } from "@/shared/types";
import { useBankAccountHoldStore } from "@/employer/store/bankAccountHold";
import _ from "lodash";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class AccountHolderBankAccountHolds extends Vue {
  bankAccountHoldStore = useBankAccountHoldStore();

  BankAccountHoldFunctionType = BankAccountHoldFunctionType;
  selectedAccountId = 0;
  isSubmitting = false;
  holdsFormModel = [];
  holdNotes = "";

  @Prop()
  username: string;

  @Prop()
  partnerId: number;

  @Prop()
  isEditMode: boolean;

  get isLoaded () {
    return this.bankAccountHoldStore.holdsLoaded && this.bankAccountHoldStore.holdTypesLoaded;
  }

  get displayHolds () {
    return this.isEditMode || this.bankAccountHoldStore.activeHolds(this.selectedAccountId).length > 0;
  }

  get displayNoAccount () {
    return !this.bankAccountHoldStore.hasAccounts;
  }

  get accounts () {
    return this.bankAccountHoldStore.allAccounts;
  }

  get widgetTitle (): string {
    return this.isEditMode ? "Edit Holds" : "Hold Details";
  }

  get showAccountSelection () {
    return this.accounts.length > 1;
  }

  get currentAccountInformation (): HoldAccountInformationModel {
    return this.accounts.find(x => x.accountId === this.selectedAccountId);
  }

  get isAccountActive (): boolean {
    return this.currentAccountInformation.accountStatus === UserHsaAccountStatus.Open;
  }

  beforeMount () {
    this.$validator.extend("holdNotes", {
      getMessage: _ => "Hold Notes may not contain line breaks or the pipe character",
      validate: _ => !/[|(\r\n|\r|\n)]/.test(this.holdNotes)
    });
  }

  mounted () {
    this.loadHoldData();
    this.bankAccountHoldStore.loadHoldTypes();
  }

  loadHoldData () {
    this.bankAccountHoldStore.loadHolds({ username: this.username, partnerId: this.partnerId });
  }

  @Watch("holdsFormModel", { deep: true })
  onHoldsFormModelChanged () {
    this.updateNavigationGuard(this.arePendingChanges());
  }

  arePendingChanges () {
    return !_.isEqual(this.holdsFormModel, this.bankAccountHoldStore.allHolds(this.selectedAccountId));
  }

  updateNavigationGuard (confirmNavigation: boolean) {
    const eventData = {
      confirmNavigation,
      message: "Are you sure you want to leave?  Your unsaved changes will be lost if you continue.  Click Cancel to return to the page to save your changes."
    };

    this.$emit("navigationGuardChange", eventData);
  }

  @Watch("isLoaded")
  @Watch("selectedAccountId")
  onHoldsLoaded () {
    if (!this.bankAccountHoldStore.hasAccounts || !this.isLoaded) {
      return;
    }

    if (this.selectedAccountId === 0) {
      this.selectedAccountId = this.bankAccountHoldStore.defaultAccountId;
    }

    if (this.isEditMode) {
      this.holdsFormModel = [ ...this.bankAccountHoldStore.allHolds(this.selectedAccountId) ];
    } else {
      this.holdsFormModel = [ ...this.bankAccountHoldStore.activeHolds(this.selectedAccountId) ];
    }
  }

  onSubmit () {
    this.$validator
        .validate()
        .then(result => {
          if (result) {
            this.save();
          }
        });
  }

  save () {
    this.isSubmitting = true;
    const items = [];
    this.holdsFormModel.forEach(hold => {
      items.push({
        holdType: hold.holdTypeId,
        isActive: hold.isActive,
        scheduledReleaseDate: hold.scheduledReleaseDate
      });
    });

    const request = {
      accountHoldVersion: this.bankAccountHoldStore.holdVersion(this.selectedAccountId),
      holdNote: this.holdNotes,
      accountHolds: items
    };

    this.bankAccountHoldStore.saveHolds({
          accountId: this.selectedAccountId,
          request,
          username: this.username,
          partnerId: this.partnerId
        })
        .then(() => this.onHoldsLoaded())
        .finally(() => {
          this.isSubmitting = false;
          this.updateNavigationGuard(false);
        });
  }

  exportHistory () {
    this.bankAccountHoldStore.exportHoldHistory({
      accountId: this.selectedAccountId,
      username: this.username,
      partnerId: this.partnerId
    });
  }
}
